/**
 * Theme preference: "system" follows the OS via the prefers-color-scheme
 * media query in index.css; "light"/"dark" force a scheme by stamping
 * data-theme on <html>, which overrides the media query.
 */
export type ThemePreference = "system" | "light" | "dark";

const STORAGE_KEY = "motionforge-theme";

export function getThemePreference(): ThemePreference {
  if (typeof window === "undefined") return "system";
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "light" || raw === "dark" || raw === "system") return raw;
  } catch {
    // storage disabled
  }
  return "system";
}

export function applyThemePreference(pref: ThemePreference) {
  const root = document.documentElement;
  if (pref === "system") {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", pref);
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, pref);
  } catch {
    // storage disabled
  }
}

/** Apply the persisted preference at boot (call before first render). */
export function initTheme() {
  applyThemePreference(getThemePreference());
}
